// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AcceptancePhotosController from "./acceptance_photos_controller"
application.register("acceptance-photos", AcceptancePhotosController)

import CartQuantumController from "./cart_quantum_controller"
application.register("cart-quantum", CartQuantumController)

import CategoryTreeController from "./category_tree_controller"
application.register("category-tree", CategoryTreeController)

import CheckoutInfoController from "./checkout_info_controller"
application.register("checkout-info", CheckoutInfoController)

import ErrorsController from "./errors_controller"
application.register("errors", ErrorsController)

import FeedbackGalleryController from "./feedback_gallery_controller"
application.register("feedback-gallery", FeedbackGalleryController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import InvoiceItemMarksController from "./invoice_item_marks_controller"
application.register("invoice-item-marks", InvoiceItemMarksController)

import InvoiceItemPhotosController from "./invoice_item_photos_controller"
application.register("invoice-item-photos", InvoiceItemPhotosController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NoticeController from "./notice_controller"
application.register("notice", NoticeController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import ProductFilterController from "./product_filter_controller"
application.register("product-filter", ProductFilterController)

import PushSubscriptionController from "./push_subscription_controller"
application.register("push-subscription", PushSubscriptionController)

import RegistrationTokenController from "./registration_token_controller"
application.register("registration-token", RegistrationTokenController)

import ReportsController from "./reports_controller"
application.register("reports", ReportsController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import UserFormController from "./user_form_controller"
application.register("user-form", UserFormController)
